import $ from "jquery";
import Util from "./../util";
import Tab from "./../tab";
import GoogleMaps from "./../googlemaps";
import Variables from "./../variables";

const PropertyDetailView = (($) => {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME = "PropertyDetailView";
  const VERSION = "4.1.1";
  const DATA_KEY = "nh.propertyDetailView";
  const EVENT_KEY = `.${DATA_KEY}`;
  const DATA_API_KEY = ".data-api";
  const JQUERY_NO_CONFLICT = $.fn[NAME];

  const ClassName = {
    FORM_VALIDATED: "nhw-form-validated",
  };

  const FormState = {
    DEFAULT: "default",
    VALIDATING: "validating",
    SUBMITTING: "submitting",
  };

  const Selector = {
    ROOT: "#nesthub-property-detail-view",
    SEARCH_FORM: "#nesthub-search-form",
    NAVIGATION: "#nesthub-property-detail-tab-list",
    NAVIGATION_TABS: "li > ." + Variables.prefix + "-nav-link",
    MAP: "#nesthub-property-view-map-panel",
    MAIN_IMAGE: "#nesthub-property-view-main-image",
    GALLERY_BTN: "#nesthub-property-view-gallery-btn",
    LEAD_FORM: "#nesthub-property-lead-form",
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class PropertyDetailView {
    constructor(element) {
      this._element = element;

      // this._searchForm = $(Selector.SEARCH_FORM, this._element)[0]
      //this._navigation = $(Selector.NAVIGATION, this._element)[0]
      this._map = null;
      this._formState = FormState.DEFAULT;

      this._init();
    }

    // Getters

    static get VERSION() {
      return VERSION;
    }

    // Public

    show() {}

    // Private

    _init() {
      const self = this;

      $(Selector.NAVIGATION_TABS, this._navigation).on(
        "click",
        function (event) {
          event.preventDefault();

          const $this = $(this);
          let data = $this.data(DATA_KEY);

          if (!data) {
            data = new Tab(this);
            $this.data(DATA_KEY, data);
          }

          data.show();

          if (this.id == "nesthub-property-map-tab") {
            self._showMap();
          }
        }
      );

      $(Selector.GALLERY_BTN, this._element).on("click", function (event) {
        $(Selector.MAIN_IMAGE).click();
      });

      if ($(Selector.MAP, this._element).length > 0) {
      }

      $(Selector.LEAD_FORM, this._element).on("submit", function (event) {
        let form = this;

        if (self._formState == FormState.SUBMITTING) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }

        self._formState = FormState.SUBMITTING;
      });
    }

    _activate() {}

    _showMap() {
      if (!this._map) {
        let $map = $(Selector.MAP, this._element);
        if ($map.length > 0) {
          let lat = parseFloat($map.data("lat"));
          let lng = parseFloat($map.data("lng"));
          let title = $map.data("title");

          this._map = new GoogleMaps($map[0]);
          this._map.show(() => {
            this._map.addMarker(lat, lng, title);
          });
        }
      } else {
        this._map.resize();
      }
    }

    _submitLead() {}

    dispose() {
      $.removeData(this._element, DATA_KEY);
      this._element = null;
    }
  }

  $(Selector.ROOT).each(function () {
    const $this = $(this);
    let data = $this.data(DATA_KEY);

    if (!data) {
      data = new PropertyDetailView(this);
      $this.data(DATA_KEY, data);
    }
  });

  return PropertyDetailView;
})($);

export default PropertyDetailView;
